export default "__VITE_ASSET__Dyo12cs7__"